<div class="blocking-overlay-backdrop" (click)="close()"></div>
<div *ngIf="enableLoadingAnimation" class="loading-container">
    <icon name='x' (click)="close()" class="close-btn"></icon>
    <div *ngIf="title" class="title">{{title}}</div>
    <div class="loader">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <img *ngIf="logoUrl" class="logo" [src]="logoUrl" alt="Loading animation image" />
    <div *ngIf="description" class="description">{{description}}</div>
    <div *ngIf="htmlText" [innerHtml]="htmlText | safeHtml"></div>
</div>